<h2 mat-dialog-title>{{data['titleDialog']}}</h2>
<mat-dialog-content>
  @if (data['nameProvider']) {
    <h3> Provedor: {{data['nameProvider']}} </h3>
  }
  <h4>Total: {{data['totalCost'] | thousandSeparator}} </h4>
  <mat-form-field>
    <mat-label>Comentario</mat-label>
    <textarea [(ngModel)]="comment" autocomplete="off" type="text" matInput #comentario rows="2" maxlength="100"
    placeholder="Comentario"></textarea>
    <mat-hint>{{ comentario.value.length }}/100</mat-hint>
  </mat-form-field>
  <data-table [columns]="data.columnasDialog" [data]="data.dataTable" [configuration]="data.configurationDialog">
  </data-table>

</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-center" align="end">
  <button color="warn" class="mr-1 button-save mat-elevation-z5 " mat-raised-button mat-dialog-close>Cancelar</button>
  <button color="primary" class="ml-1 button-save mat-elevation-z5" mat-raised-button
  [mat-dialog-close]="[true, comment]" cdkFocusInitial>Guardar</button>
</mat-dialog-actions>

<style>
  mat-form-field {
  width: 100% !important;
}

.button-save {
width: 20%;
}

@media screen and (max-width: 550px) {
.button-save {
width: 35%;
}
}
</style>